import { render } from "./DropFile.vue?vue&type=template&id=3f7ff9c2"
import script from "./DropFile.vue?vue&type=script&lang=js"
export * from "./DropFile.vue?vue&type=script&lang=js"

import "./DropFile.vue?vue&type=style&index=0&id=3f7ff9c2&lang=css"

import exportComponent from "/var/www/mcd-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__